import Vue from 'vue'
import {RUN_PAN_VERIFY,RUN_VERIFY_LEAD_OTP,RUN_AI_STOCK_EMAIL,RUN_CREATE_LEAD,RUN_VERIFY_DOB, RUN_FETCH_DOB, RUN_CONTACT_US,GET_INFO,GET_TOKEN,GET_USER,GET_LOADERS,SET_INFO,SET_STATE,SET_TOGGLE_LOADER,GET_MARGIN_CALCULATOR_LIST,
	SET_MARGIN_CALCULATOR_LIST,RUN_WEB_ENGAGE_USER,
	RUN_MARGIN_CALCULATOR, RUN_STATUS_CVL} from '../types'
import * as RxFactory from './api/rx-factory'
import * as types from '@/types'
import CryptoJS from 'crypto-js';

export const BASE_URL 					= 				 process.env.LOCAL_FACADE_SERVER_FULL_ADDRESS
export const EP_VERIFY_PAN				= 				'/api/verify/pan'
export const EP_CREATE_LEAD 			= 				'/api/create/lead'
export const EP_VERIFY_OTP_LEAD 		= 				'/api/verify/otp/lead'
export const EP_VERIFY_DOB 				= 				'/api/verify/kra'
export const EP_FETCH_DOB 				=				'/api/digitap/pan_details'
export const EP_MARGIN_CALCULATOR		= 				'/api/website/marginCalculator'
export const EP_CONTACT_US				=				'/contact/us'
export const EP_AI_STOCK_EMAIL 			=				'/ai/stock/email'
export const EP_WEB_ENGAGE_USER         =               '/api/verify/webengage/user'
export const EP_STATUS_CVL              =               '/api/cvl/status'

export const actions = {
	
	[RUN_MARGIN_CALCULATOR]({commit, state, dispatch,getters}, req){
		try{				
		RxFactory.get(BASE_URL + EP_MARGIN_CALCULATOR, req)			  
			  .map(response => response.data)			  
			  .subscribe(data => {
				  if ('info' in data) {
					  if (data.info === 'OK') {
						commit(SET_MARGIN_CALCULATOR_LIST, data.data)  
					  }					  
				  }
			  },
			  e => {
				  _handleErrorResponse(e, commit)
			  }
		)
	  } catch (ex) {
		  _handleErrorResponse(ex, commit)
	  }
	},
	[RUN_STATUS_CVL]({commit, state, dispatch,getters}, credentials){
		return new Promise((resolve, reject) => {
			try{
				const parameter = credentials.parameter
				delete credentials.parameter
				const rout = credentials.rout
				delete credentials.rout
				parameter.pageLoader = true       

				RxFactory.post(BASE_URL + EP_STATUS_CVL, credentials)
					.map(response => response.data)
					.subscribe(data => {
						parameter.pageLoader = false
						if ('info' in data) {
							if (data.info === 'OK') {
								resolve(data.data)
								parameter.pan_var_verify = true
								// parameter.res_msz= 'status fetched successfully'
								// parameter.mszType = 'success'
							}
							else{	
								reject(false)
								parameter.res_msz= data.msg
								parameter.mszType = 'error'
							}
						}
					},
					e => {
						reject(false)
						_handleErrorResponse(e, commit)
					}
				)
			} catch (ex) {
				reject(false)
				_handleErrorResponse(ex, commit)
			}
		
		});
	},
	[RUN_PAN_VERIFY]({commit, state, dispatch,getters}, credentials){
		try{
			const parameter = credentials.parameter
			delete credentials.parameter
			const rout = credentials.rout
		  delete credentials.rout
		parameter.pageLoader = true

		RxFactory.post(BASE_URL + EP_VERIFY_PAN, credentials)
			  .map(response => response.data)
			  .subscribe(data => {
				  parameter.pageLoader = false
				  if ('info' in data) {
					  if (data.info === 'OK') {
						  parameter.pan_var_verify = true
						  parameter.res_msz= 'pan verified successfully'
						  parameter.mszType = 'success'
					  }
					  else{	
						 parameter.res_msz= data.msg
						 parameter.mszType = 'error'
					  }
				  }
			  },
			  e => {
				  _handleErrorResponse(e, commit)
			  }
		)
	  } catch (ex) {
		  _handleErrorResponse(ex, commit)
	  }
	},
	[RUN_CREATE_LEAD]({commit, state, dispatch,getters}, credentials){
		try{
			const parameter = credentials.parameter
			delete credentials.parameter
			const router = credentials.router
		  delete credentials.router
		  parameter.pageLoader = true
			console.log(credentials)

			let encryptClientCode = (val) => {
				if (val) {
					try {
						const key = CryptoJS.enc.Utf8.parse(process.env.VITE_CRYPTO_ENCRYPTION_KEY_LEAD);
						const iv = CryptoJS.enc.Utf8.parse(process.env.VITE_CRYPTO_ENCRYPTION_IV_LEAD);
						const encrypted = CryptoJS.AES.encrypt(val, key, {
							iv: iv,
							mode: CryptoJS.mode.CBC,
							padding: CryptoJS.pad.Pkcs7
						});
						return encrypted.toString();
					} catch (error) {
						console.error('Decryption error:', error);
						return null;
					}
				}
				return null;
			};
			let encodedObject = encryptClientCode(JSON.stringify(credentials))
			parameter.disableButton = true;
			RxFactory.post(BASE_URL + EP_CREATE_LEAD, {data: encodedObject})
			  .map(response => response.data)
			  .subscribe(data => {parameter.pageLoader = false
				  if ('info' in data) {
					  if (data.info === 'OK') {
						parameter.disableButton = false;
					  	window.gtag('event', 'OTP_Gen_Lead', {'event_name': 'OTP_Gen_Lead', 'send_to': 'G-R9YMKPBHC5'});
					  	window.fbq('track', 'initiate checkout');
						parameter.inserted_id = data.data.insertId
						parameter.res_msz = "We have sent an OTP on email and mobile number that you have provided!";
						parameter.mszType = 'success'
						if(parameter.resendOTPCallback) {
							console.log("Resend OTP Completed")
							webengage.track("Resend OTP Completed", {"Value": "Yes"});
						}
					}
					  else{	
						parameter.disableButton = false;
						parameter.email = '';
						parameter.mobile = '';
						parameter.submitted = false;
						parameter.res_msz= data.msg	
						parameter.mszType = 'error'
						if(parameter.resendOTPCallback) {
							console.log("Resend OTP Failed")
							webengage.track("Resend OTP Failed", {"Value": "Yes"});
						}
						 
					}
				  }
			  },
			  e => {
				  _handleErrorResponse(e, commit)
			  }
		  )
	  } catch (ex) {
		  _handleErrorResponse(ex, commit)
	  }
	},
	[RUN_WEB_ENGAGE_USER] ({commit, state}, credentials) {
		try {
			const parameter = credentials.parameter
			delete credentials.parameter
			const rout = credentials.rout
		  	delete credentials.rout
			console.log('test-------')
			RxFactory.post(BASE_URL + EP_WEB_ENGAGE_USER, credentials)
				.map(response => response.data)
				.subscribe(data => { 
					if ('info' in data) {
						if (data.info === 'OK') {
							let res_data = data.data[0]
							webengage.user.login(res_data.custom_id);

							if(parameter.user_details) {
								const currentUser = parameter.user_details;
								if(!currentUser.FROM_KRA) {
									webengage.track("Non Kra User", {"Value": "Yes"});
									console.log("Non Kra User")
								}

								if(currentUser && currentUser.username) {
									const username = currentUser.username.split(' ');
									if(username[0]) {
										webengage.user.setAttribute('we_first_name', username[0]);
									}
									if(username.length > 1) {
										webengage.user.setAttribute('we_last_name', username[length - 1]);
									}
									webengage.user.setAttribute("FullName", currentUser.username);
								}
							}
							
							webengage.user.setAttribute("we_email", res_data.email);
							webengage.user.setAttribute("we_phone", res_data.mobile);

							parameter.webEngageId = res_data.custom_id
						} else {
							parameter.res_msz= data.msg
							parameter.mszType = 'error'
						}
					} 
				},
				e => {
					_handleErrorResponse(e, commit)
				}
			)
		} catch (ex) {
			_handleErrorResponse(ex, commit)
		}
    },
	// [RUN_WEB_ENGAGE_USER]({commit, state, dispatch,getters}, credentials){
	// 	return new Promise((resolve, reject) => {
	// 		try {
	// 			debugger
	// 			const parameter = credentials.parameter
	// 			delete credentials.parameter
	// 			const router = credentials.router
	// 			delete credentials.router
	// 			// parameter.disableloginBtn = true;
	// 			RxFactory.post(BASE_URL + EP_WEB_ENGAGE_USER,parameter,credentials)
	// 			 .map(response => response.data)
	// 				.subscribe(data => {parameter.pageLoader = false
	// 					if ('info' in data) {
	// 						if (data.info === 'OK') {
							
	// 							webengage.user.login(result.res_data[0].custom_id);
	// 							let currentUser = getters['GET_USER'];
	// 							if(currentUser.username) {

	// 								const username = currentUser.username.split(' ');
									
	// 								if(username[0]) {
			
	// 									webengage.user.setAttribute('we_first_name', username[0]);
	// 								}

	// 								if(username.length > 1) {
	// 									webengage.user.setAttribute('we_last_name', username[length - 1]);
	// 								}

	// 								webengage.user.setAttribute("FullName", currentUser.username);
	// 							}
	// 							webengage.user.setAttribute("we_email", result.res_data[0].email);
	// 							webengage.user.setAttribute("we_phone", result.res_data[0].mobile_no);

	// 							parameter.webEngageId = result.res_data[0].custom_id
								
	// 						}
	// 					}else{
	// 						// parameter.disableloginBtn = false;
	// 						parameter.res_msz= data.msg
	// 						parameter.mszType = 'error'
	// 					}
	// 			})
	// 		} catch (ex) {
	// 		reject(ex); // Reject the Promise with the caught error.
	// 		}
	// 	});
		
	// },
	[RUN_VERIFY_LEAD_OTP]({commit, state, dispatch,getters}, credentials){
		try{
			const parameter = credentials.parameter
			delete credentials.parameter
			const router = credentials.router
		  delete credentials.router
		 parameter.pageLoader = true
			RxFactory.post(BASE_URL + EP_VERIFY_OTP_LEAD, credentials)
			  .map(response => response.data)
			  .subscribe(data => {parameter.pageLoader = false
				  if ('info' in data) {
					  if (data.info === 'OK') {
						  parameter.STEP = 2
						  window.gtag('event', 'OTP_verify', {'event_name': 'OTP_verify', 'send_to': 'G-R9YMKPBHC5'});
						    window.gtag('event', 'conversion', {'send_to': 'AW-975363956/nNhRCI6dgP8CEPS-i9ED'});
							window.rdt('track', 'Lead')
							window.fbq('track', 'lead');
							window.qp('track', 'GenerateLead');
						   parameter.res_msz = 'OTP is verified successfully.'
						   parameter.mszType = 'success'
						  if(parameter.verifyOTPCallback) {
							console.log("OTP Verified Sucess")
							webengage.track("OTP Verified Sucess", {"Value": "Yes"});
						  }
					  }
					  else{	
					
						parameter.res_msz= data.msg	
						parameter.mszType = 'error'
						if(parameter.verifyOTPCallback) {
							console.log("OTP Verified Failed")
							webengage.track("OTP Verified Failed", {"Value": "Yes"});
						}
					}
				  }
			  },
			  e => {
				  _handleErrorResponse(e, commit)
			  }
		  )
	  } catch (ex) {
		  _handleErrorResponse(ex, commit)
	  }
	},
	[RUN_VERIFY_DOB]({commit, state, dispatch,getters}, credentials){
		try{
			const parameter = credentials.parameter
			delete credentials.parameter
			const rout = credentials.rout
		  delete credentials.rout
		  parameter.pageLoader = true
			RxFactory.post(BASE_URL + EP_VERIFY_DOB, credentials)
			  .map(response => response.data)
			  .subscribe(data => {parameter.pageLoader = false
				  if ('info' in data) {
					  if (data.info === 'OK') {
						//   let path
						 //  data.data.user.loggedIn = true
						//   commit(SET_STATE, data.data.user)
						//   localStorage.setItem('user', btoa(JSON.stringify(data.data.user)))
						  
						 //parameter.res_msz = "Thankx for register with us , Your username and password sent your register email id !" 
						//parameter.mszType = 'success'
						
						parameter.webEngageUser(data.data.user)
						console.log("Confirm Pan Card Success")
						webengage.track("Confirm Pan Card Success", {"Value": "Yes"});  
						window.gtag('event', 'PAN/DOB_Verify', {'event_name': 'PAN/DOB_Verify', 'send_to': 'G-R9YMKPBHC5'});
						let url = "https://prism.shoonya.com/?token="+data.data.user.token
						window.open(url,'_self');
						//rout.replace({ name: "Users.UserRegisterStepZero",query:{msz:message } })  
					  }
					  else{	parameter.res_msz= data.msg
					  	parameter.mszType = 'error'
						  console.log("Confirm Pan Card Failed")
						  webengage.track("Confirm Pan Card Failed", {"Value": "Yes"});
						
						}
				  }
			  },
			  e => {
				  _handleErrorResponse(e, commit)
			  }
		  	)
	  } catch (ex) {
		  _handleErrorResponse(ex, commit)
	  }
	},
	[RUN_FETCH_DOB]({commit}, credentials){
		try{
			const parameter = credentials.parameter
			delete credentials.parameter
			const rout = credentials.rout
		  	delete credentials.rout
		  	parameter.pageLoader = true
			RxFactory.post(BASE_URL + EP_FETCH_DOB, credentials)
			  	.map(response => response.data)
			  	.subscribe(data => {parameter.pageLoader = false
				  	if ('info' in data) {
					  	if (data.info === 'OK') {
							
							console.log("Verify Pan Card Success")
							webengage.track("Verify Pan Card Success", {"Value": "Yes"});  
							parameter.isUserFetched = true;
							parameter.fullName = data.data.panInfoRes.fullName;
							parameter.dob = data.data.panInfoRes.dob;
					  	}
					  	else{
							console.log("Verify Pan Card Failed")
						 	webengage.track("Verify Pan Card Failed", {"Value": "Yes"});
							parameter.isUserFetched= false;
							parameter.res_msz= data.msg
							parameter.mszType = 'error'
						}
				  	}
			  	},
				e => {
					_handleErrorResponse(e, commit)
				}
		  	)
	  } catch (ex) {
		  _handleErrorResponse(ex, commit)
	  }
	},
	
	[RUN_CONTACT_US] ({commit, state}, credentials) {
		try {
			credentials.localParams.parameter.pageLoader = true
			credentials.localParams.parameter.disabledVar = true
			RxFactory.post(BASE_URL + EP_CONTACT_US, credentials.globalParams)
				.map(response => response.data)
				.subscribe(data => { 
					if ('info' in data) {
						credentials.localParams.parameter.pageLoader = false
						credentials.localParams.parameter.disabledVar = false
						if (data.info === 'OK') {
							credentials.localParams.parameter.errorMsg = 'Thank you for contacting us! We will be in touch soon!'
							credentials.localParams.parameter.msgType = 'success'
							credentials.localParams.parameter.cleanVar()
						} else {
							credentials.localParams.parameter.errorMsg = data.msg
							credentials.localParams.parameter.msgType = 'error'
						}
					} 
				},
				e => {
					_handleErrorResponse(e, commit)
				}
			)
		} catch (ex) {
			_handleErrorResponse(ex, commit)
		}
    },

    [RUN_AI_STOCK_EMAIL] ({commit, state}, credentials) {
		try {
			credentials.localParams.parameter.pageLoader = true
			RxFactory.post(BASE_URL + EP_AI_STOCK_EMAIL, credentials.globalParams)
				.map(response => response.data)
				.subscribe(data => { 
					if ('info' in data) {
						credentials.localParams.parameter.pageLoader = false
						if (data.info === 'OK') {
							if(credentials.localParams.form == 'second'){
								credentials.localParams.parameter.response_msg1 = 'Thanks! Stay tuned for updates via email.'
								credentials.localParams.parameter.msg_type1 = 'success'
							}else{
								credentials.localParams.parameter.response_msg = 'Thanks! Stay tuned for updates via email.'
								credentials.localParams.parameter.msg_type = 'success'
							}
							
							credentials.localParams.parameter.cleanVar()
						} else {
							if(credentials.localParams.form == 'second'){
								credentials.localParams.parameter.response_msg1 = data.msg
								credentials.localParams.parameter.msg_type1 = 'error'
							}else{
								credentials.localParams.parameter.response_msg = data.msg
								credentials.localParams.parameter.msg_type = 'error'
							}
							
						}
					} 
				},
				e => {
					_handleErrorResponse(e, commit)
				}
			)
		} catch (ex) {
			_handleErrorResponse(ex, commit)
		}
    },
	
}
//--------------------------------functions--------------------------------------
function _cleanUp (commit, msg, status, loaderId) {
  let loaderArr = (typeof loaderId !== 'undefined') ? [loaderId] : []
  commit(SET_TOGGLE_LOADER, loaderArr)
  commit(SET_INFO, msg)
}
function _handleErrorResponse (e, commit) {
    let response = {info: 'NOK', msg: 'Service not available'}
	if (typeof e.response === 'undefined') {
		try {
			const statusCheck = e.toString().toLowerCase()
			if (statusCheck.indexOf('network') > -1) {
			response = {info: 'NOK', msg: 'Network Error'}
			}
		} catch(e){}
	}else{
		if(e.response.status == '401'){
			let user = {
				active: 0,
				country: '',
				created: '',
				email: '',
				profile: {
					firstname: '',
					lastname: '',
					pid: '',
					cid: ''
				},
				roles: '',
				token: false,
				username: '',
				loggedIn: false
			}
			commit(SET_STATE, user)
			localStorage.setItem('user', '')
			window.location.href = "/";
		}
		response = e.response.data
	}
	_cleanUp(commit, response, response.status)
}
function _handleLogout (data, commit,options,getters) {
	const router = options.router
	// let user = {
		// active: 0,
		// country: '',
		// created: '',
		// email: '',
		// profile: {
			// firstname: '',
			// lastname: '',
			// pid: '',
			// cid: ''
		// },
		// roles: '',
		// token: false,
		// username: '',
		// loggedIn: false
	// }
	let user = {}
	localStorage.removeItem("user");
	localStorage.removeItem("margin_info");
	commit(SET_STATE, user)
	commit(SET_STATE_PERSIST_LOCAL)
	if ( 'msg' in data && 'info' in data) {
		_cleanUp(commit, data.msg, data.info)
	}
	if (options.forward === true) {
		
		router.replace('/')
	}
}





// WEBPACK FOOTER //
// ./src/store/actions.js